// extracted by mini-css-extract-plugin
module.exports = {"root":"agenda-card_root__SFo95","text":"agenda-card_text__vvIB7","badges":"agenda-card_badges__dKXHY"};